import React, { useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { history } from "configureStore";

const CHAT_PATH = "/app/chat";
// The admin panel's phone layout starts at this width (its theme's `md` breakpoint).
const PHONE = "768px";

const isChatPage = (pathname) => pathname.replace(/\/$/, "") === CHAT_PATH;

// On phones the chat fills the screen below the top bar (nutivate-coaches#77), as the members' website does (#86):
// no page margin or grey border around it, the message list keeps 8px at its sides instead of 40px (#66), and
// scrolling past the first or last message doesn't carry on into the page, which iPhone Safari would drag up.
const PhoneChatStyle = createGlobalStyle`
  @media only screen and (max-width: ${PHONE}) {
    html,
    body {
      overscroll-behavior-y: none;
    }

    /* The admin panel's layout is at least 100vh tall, set on the element itself. On iPhone Safari that is the
       height with the toolbar hidden, taller than the visible screen, so the page could be dragged up from
       outside the message list (#81). The chat below sets the height instead. */
    .ant-pro-basicLayout section.ant-layout {
      min-height: 0 !important;
    }

    .ant-layout-content.ant-pro-basicLayout-content {
      margin: 0;
    }

    /* The admin panel's chat wrapper: a -20px top margin, a grey border and the window height minus 90px. */
    .ant-layout-content.ant-pro-basicLayout-content > div:first-child {
      margin-top: 0;
      border: none;
      ${({ height }) => (height ? `height: ${height}px;` : "")}
    }

    #message-list {
      padding-left: 8px;
      padding-right: 8px;
      overscroll-behavior-y: contain;
    }
  }
`;

// The height left below the top bar, measured once the page margin is gone, and again on every resize.
const useHeightBelowTopBar = (active) => {
  const [height, setHeight] = useState(null);

  useEffect(() => {
    if (!active) return undefined;
    let frame = null;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const content = document.querySelector(".ant-layout-content.ant-pro-basicLayout-content");
        if (content) setHeight(Math.round(window.innerHeight - content.getBoundingClientRect().top));
      });
    };
    measure();
    window.addEventListener("resize", measure);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", measure);
    };
  }, [active]);

  return height;
};

// Adds the phone styles only while the chat page is open, so the coaches' other pages keep their margins.
const ChatPageStyles = () => {
  const [pathname, setPathname] = useState(history.location.pathname);
  useEffect(() => history.listen((location) => setPathname(location.pathname)), []);

  const onChatPage = isChatPage(pathname);
  const height = useHeightBelowTopBar(onChatPage);

  return onChatPage ? <PhoneChatStyle height={height} /> : null;
};

export default ChatPageStyles;
